import { render, staticRenderFns } from "./DialogSequence.vue?vue&type=template&id=2520bca3"
import script from "./DialogSequence.vue?vue&type=script&lang=js"
export * from "./DialogSequence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports